export default "__VITE_ASSET__BZOur6gW__"